<template>
    <div id="contract-type-modal" class="modal fade" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
            <form class="modal-content" @submit.prevent="sendTypeData" autocomplete="off">
                <header class="modal-header">
                    <h5 class="modal-title">Добавить шаблон договора</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </header>
                <div class="modal-body">
                    <div class="alert mb-3" :class="info ? 'alert-success alert-dismissible' : 'alert-danger'" v-if="info || error" role="alert">
                        {{ info || error }}
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" v-if="info"></button>
                    </div>
                    <div class="mb-3">
                        <label for="name-input" class="form-label">Название шаблона:</label>
                        <input id="name-input" v-model.trim="newContractType.NAME" type="text" class="form-control" required />
                    </div>
                    <div class="mb-3">
                        <label for="cat-select" class="form-label">Название категории:</label>
                        <input id="cat-input" v-model.trim="newContractType.CATEGORY" type="text" class="form-control" required />
                    </div>
                    <div v-if="villages.length">
                        <label for="meter-select" class="form-label">Поселок:</label>
                        <select id="meter-select" v-model.number="newContractType.VILLAGE" class="form-select" required>
                            <option
                                v-for="(village, key) in villages"
                                :key="key"
                                :value="village.ID"
                                >
                                {{ village.NAME }}
                            </option>
                        </select>
                    </div>
                </div>
                <footer class="modal-footer justify-content-center">
                    <button class="btn btn-primary">Создать</button>
                </footer>
                <div class="form-row" v-if="info">{{ info }}</div>
            </form>
        </div>
    </div>
</template>

<script>
    import config from "@/config";

    export default {
        name: "ContractTypeAdd",
        data() {
            return {
                url: config.backend_url,
                villages: [],
                newContractType: {
                    NAME: null,
                    CATEGORY: null,
                    VILLAGE: null
                },
                info: null,
                error: null
            };
        },
        methods: {
            sendTypeData: function ()
            {
                this.info = this.error = null;
                this.$store
                    .dispatch("query/sendRequest", {
                        url: this.url + "agreementtypelist/add/",
                        data: this.newContractType,
                        method: "POST"
                    })
                    .then(response => {
                        let data = response.data;
                        if (!data.error) {
                            this.info = "Шаблон договора добавлен";
                            this.$emit("contract-type-add");
                        } else {
                            this.error = data.error || 'Шаблон договора не был добавлен';
                        }
                    }).catch(err => {
                        this.error = err;
                    });
            },
            getVillages: function ()
            {
                this.$store
                    .dispatch("query/sendRequest", {
                        url: this.url + "villages/get-user-villages/",
                        data: {},
                        method: "POST"
                    })
                    .then(response => {
                        let data = response.data;
                        if (!data.error) {
                            this.villages = Object.values(data).map(function(village) {
                                return {NAME: village.NAME, ID: village.ID};
                            });
                        }
                    });
            }
        },
        mounted() {
            this.getVillages();
        }
    };
</script>
